module.exports = __webpack_public_path__ + "static/media/email4.cb9d0e8b.png";